/**
 * Canonical Account History list-column amounts for all portals.
 * Fee-only companion rows (SENDER_PAID_FEES) store postage/attached as
 * fee-base context for the detail dialog; list columns must not treat
 * those as Reserved/Credited balance movement.
 */

export type AccountHistoryListAmountInput = {
  rawType?: string | null;
  requiredPostage?: number | null;
  postage?: number | null;
  attachedFunds?: number | null;
  attachedAmount?: number | null;
  postageSystemFee?: number | null;
  attachedFundsFee?: number | null;
  systemFeeAmount?: number | null;
};

export type AccountHistoryListAmounts = {
  isFeeOnlyRow: boolean;
  /** Postage column for the list (0 on fee-only rows). */
  listPostage: number;
  /** Attached Credits column for the list (0 on fee-only rows). */
  listAttached: number;
  /** Reserved/Credited column base (postage + attached; 0 on fee-only). */
  totalReservedOrCredited: number;
  totalSystemFees: number;
};

export function isSenderPaidFeesRow(rawType?: string | null): boolean {
  return (rawType ?? '').toUpperCase() === 'SENDER_PAID_FEES';
}

export function getAccountHistoryListAmounts(
  tx: AccountHistoryListAmountInput
): AccountHistoryListAmounts {
  const isFeeOnlyRow = isSenderPaidFeesRow(tx.rawType);
  const requiredPostage = tx.requiredPostage ?? tx.postage ?? 0;
  const attachedFunds = tx.attachedFunds ?? tx.attachedAmount ?? 0;
  const postageSystemFee = tx.postageSystemFee ?? 0;
  const attachedFundsFee = tx.attachedFundsFee ?? 0;
  const systemFeeAmount = tx.systemFeeAmount ?? 0;
  const totalSystemFees = postageSystemFee + attachedFundsFee + systemFeeAmount;

  if (isFeeOnlyRow) {
    return {
      isFeeOnlyRow: true,
      listPostage: 0,
      listAttached: 0,
      totalReservedOrCredited: 0,
      totalSystemFees,
    };
  }

  return {
    isFeeOnlyRow: false,
    listPostage: requiredPostage,
    listAttached: attachedFunds,
    totalReservedOrCredited: requiredPostage + attachedFunds,
    totalSystemFees,
  };
}
